<template>
    <div id="error-page">
        <div class="cog"><i class="fas fa-cog"></i></div>
        <div class="flex-center position-ref full-height">
            <div class="content">
                <h1>System Maintenance</h1>
                <p>Sorry about this, but we are currently performing some system maintenance. Please try again later.</p>
                <router-link to="/" class="logo">
                    <svg id="logo-icon" data-name="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60.17 53.83">
                        <path class="cls-1" d="M60.21,50.77S34,47.78,8.74,53V50.59s31.16-6,54.17-4.56Z" transform="translate(-8.74 -45.42)" />
                        <path class="cls-2" d="M64.56,67.71s-3.9-2.81-3.08-5.25,7.34-15.68,7.34-15.68.45-1.45-.64-1.36-4.35,0-4.35,0a3.94,3.94,0,0,0-2.23,2.33C60.68,49.75,38,94.44,38,94.44s-1.65,2.36,1.39,2.45,24.52-.64,24.52-.64a4,4,0,0,0,2.81-3.17c.27-2.44,1.9-17.48,1.54-18.93a6.09,6.09,0,0,0-3.71-6.44Z" transform="translate(-8.74 -45.42)" /><path class="cls-2" d="M57.13,53H50.78L27.59,99.24h10l1.17-1.9s-1.9.09-3.21,0-.41-1-.41-1l5.59-11,5.06,1.74V85.46L41.41,84,52.23,62.67l4.35,1.5V62.54l-3.64-1.26Z" transform="translate(-8.74 -45.42)" />
                        <path class="cls-1" d="M278.46,71" transform="translate(-8.74 -45.42)" />
                    </svg>
                </router-link>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import url("//fonts.googleapis.com/css?family=Nunito:200,600");

    @keyframes rotate {
        0% { -webkit-transform: rotate(0deg); }
        25% { -webkit-transform: rotate(90deg); }
        50% { -webkit-transform: rotate(180deg); }
        75% { -webkit-transform: rotate(270deg); }
        100% { -webkit-transform: rotate(360deg); }
    }

    .cog {
        position: absolute;
        z-index: 0;
        bottom: -15vh;
        left: -20vh;
        font-size: 30vh;
        color: #4E658B;
        animation: rotate 120s 1s linear infinite;
    }

    #app {
        background: #25568D;
    }

    #main {
        padding: 0;
    }

    #error-page {
        font-family: 'Nunito', sans-serif;
        font-weight: 200;
        color: #ebebeb;

        .full-height {
            height: 100vh;
        }

        .flex-center {
            align-items: center;
            display: flex;
            justify-content: center;
        }

        .position-ref {
            position: relative;
        }

        .content {
            text-align: center;
        }

        h1 {
            font-size: 10vh;
            margin: 0 0 40px;
            color: #ebebeb;
        }

        p {
            color: #d6d6d6;
            font-size: 1.2em;
            max-width: 500px;
            margin: 0 auto;
            font-weight: 700;
            position: relative;
            letter-spacing: .02em;
        }
        .logo {
            width: 50px;
            text-align: center;
            margin: 60px auto;
            opacity: .2;
            text-decoration: none;
            color: #fff;
            display: block;
            transition: all .2s ease;
        }
        .logo:hover {
            opacity: 1;
        }

        .cls-1 { fill: #F5F5F5 }
        .cls-2 { fill: #FFFFFF }

        @-webkit-keyframes Gradient {
            0% {
                background-position: 0% 50%
            }
            50% {
                background-position: 100% 50%
            }
            100% {
                background-position: 0% 50%
            }
        }

        @-moz-keyframes Gradient {
            0% {
                background-position: 0% 50%
            }
            50% {
                background-position: 100% 50%
            }
            100% {
                background-position: 0% 50%
            }
        }

        @keyframes Gradient {
            0% {
                background-position: 0% 50%
            }
            50% {
                background-position: 100% 50%
            }
            100% {
                background-position: 0% 50%
            }
        }
    }
</style>

<script>
import { mapMutations } from 'vuex'
import { INIT_STATUS } from '@/store/actions/init'

export default {
  name: 'Maintenance',
  data () {
    return {
      timer: false
    }
  },
  methods: {
    ...mapMutations([
      'setPageTitle'
    ]),
    checkStatus () {
      this.$store.dispatch(INIT_STATUS).then(response => {
        clearTimeout(this.timer)
        this.$store.dispatch('AUTH_LOGOUT')
        this.$router.push({ name: 'dashboard' })
      })
    }
  },
  mounted () {
    this.setPageTitle('System Maintenance')
    this.checkStatus()
    this.timer = window.setInterval(() => {
      this.checkStatus()
    }, 60 * 1000)
    this.$store.dispatch('AUTH_LOGOUT')
    this.$store.commit('doneLoading', { root: true })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Error/Maintenance.vue